import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ff5500",
        secondary: colors.shades.black,
        accent: colors.indigo.base,
      },
    },
  },
});
